import Vue from 'vue'
// resources
import EntitiesResource from '../../resources/entities'
// components&views
import ApproversGrid from '../../components/approvers_grid/ApproversGrid.vue'
import UserRolesGrid from '../../components/user_roles_mx_grid/UserRolesMxGrid.vue'
import UsersGrid from '../../components/users_grid/UsersGrid.vue'
import DepartmentGrid from '../../components/department_grid/DepartmentGrid.vue'
import FormResourceEdit from '../../components/form_resource_edit/FormResourceEdit.vue'
import AutoComplete from '../../components/Autocomplete.vue'
import CreateUser from '../create_user/CreateUser.vue'
import CreateEntity from '../create_entity/CreateEntity.vue'
import UpdateUser from '../update_user/UpdateUser.vue'
// mixins
import toastMixin from '../../mixins/toast'
import modalMixin from '../../mixins/modal'

export default Vue.extend({
    data() {
        return {
            autoCompleteResource: null,
            entityId: null,
            userResource: null,
            userRolesResource: null,
            approverResource: null,
            entityResource: null,
            isSavingUser: false,
            isSavingUserRole: false,
            isSavingApprover: false,
            agGridClickedUserId: null,
            agGridClickedDepartmentId: null,
            recentlyCreatedUserId: null,
            userForm: false,
            userRoleForm: false,
            approverForm: false,
        }
    },
    mixins: [toastMixin, modalMixin],
    components: {
        ApproversGrid,
        UsersGrid,
        UserRolesGrid,
        DepartmentGrid,
        AutoComplete,
        FormResourceEdit,
        CreateUser,
        CreateEntity,
        UpdateUser,
    },
    methods: {
        async userSelectedResource(resource) {
            if (resource && resource.id) {
                this.entityResource = resource
                resource.resolveRelated()
                this.entityId = resource.id
                this.agGridClickedUserId = null // removes user roles ag grid when new entity is selected
            }
        },
        handleApproverRowClicked(approverResource) {
            if (approverResource && approverResource[0]) {
                this.agGridClickedUserId = approverResource[0].attributes.user_id
                this.agGridClickedDepartmentId = approverResource[0].attributes.department_id
            }
        },
    },
    mounted() {
        this.autoCompleteResource = EntitiesResource
    },
})
